import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/stock-out_/new')({
  validateSearch: (search: Record<string, unknown>): { reservationId?: string } => ({
    reservationId: typeof search.reservationId === 'string' ? search.reservationId : undefined,
  }),
});
